// 问卷相关接口
import request from "@/utils/interceptor.js";

const questionnaireApi = {
  // 获取问卷列表
  getList(params) {
    return request({ url: "/api/pas/questionnaire-info", method: "get", params });
  },
  // 新增问卷
  addQuestionnaire(data) {
    return request({ url: "/api/pas/questionnaire-info", method: "post", data });
  },
  editQuestionnaire(data) {
    return request({ url: `/api/pas/questionnaire-info/${data.id}`, method: "put", data });
  },
  // 获取SysData
  getSysData(questionId) {
    return request({
      url: `/api/pas/questionnaire-info/produce-question-sysdata/${questionId}`,
      method: "post",
    });
  },
  // 获取收集问卷sysData
  getCollectSysData(patientId) {
    return request({
      url: `/api/pas/collect-questionnaire-info/produce-collect-question-sys-data/${patientId}`,
      method: "post",
    });
  },
  // 获取问卷token
  getToken() {
    return request({
      url: `/api/pas/questionnaire-info/produce-question-token`,
      method: "post",
    });
  },
  // 删除问卷
  delete(id) {
    return request({ url: `/api/pas/questionnaire-info/${id}`, method: "delete" });
  },
  // 获取收集问卷列表
  getCollectedList(params) {
    return request({
      url: "/api/pas/collect-questionnaire-info",
      method: "get",
      params,
    });
  },
  // 修改问卷发布状态
  updatePublishStatus(id, issueState) {
    return request({
      url: `/api/pas/questionnaire-info/${id}/question-issuestate`,
      method: "put",
      params: { issueState },
    });
  },
  // 删除收集问卷
  deleteCollectQuestionnaire(id) {
    return request({
      url: `/api/pas/collect-questionnaire-info/${id}`,
      method: "delete",
    });
  },
  // 获取问卷地址
  getQuestionnaireAddress() {
    return request({
      url: "/api/pas/questionnaire-info/question-url",
      method: "get",
    });
  },
  // 统计完成数量和正在进行中的数量
  getStatisticData(params) {
    return request({
      url: "/api/pas/collect-questionnaire-info/statistic",
      method: "get",
      params,
    });
  },

  // 根据qid 显示问卷题目
  getQidDisplayList(qId){
    return request({
      url:`/api/pas/questionnaire-info/displaylist/${qId}`,
      method: "get",
    })
  }
};

export default questionnaireApi;
